<!--
 * @FilePath: sgsmanager.vue
 * @Author: chenwei
 * @Date: 2022-07-07 09:18:16
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-27 14:23:39
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
    <div>
        <Header></Header>
        <div class="sgsmanagerContent">
            <iframe id="sgsmanager" class="iframesgsmanagerContent" :src="url" frameborder="0"
                scrolling="no"></iframe>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import Footer from '../../components/Footer.vue'
    import Header from '../../components/Header.vue'
    import axios from 'axios'
    export default {
        name: "index",
        components: {
            Footer,
            Header
        },
        data() {
            return {
                url: '',
                timer:null
            }
        },
        computed:{
            ...mapGetters(['themeStatis']),
        },
        mounted() {
            const language = localStorage.getItem('language')
            axios.get('config/iframeConfig.json').then(res => {
                if(language==="en"){
                    this.url = res.sgsmanagerEn
                    if (res.data) {
                        this.url = res.data.sgsmanagerEn
                    }
                }else{
                    this.url = res.sgsmanager
                    if (res.data) {
                        this.url = res.data.sgsmanager
                    }
                }
                this.firstTheme()
            })
        },
        methods:{
            firstTheme(){
                let that = this
                var indexs = 0
                this.timer = setInterval(() =>{
                    let iframeC = document.getElementById('sgsmanager')
                    iframeC.contentWindow.postMessage({ theme: that.themeStatis}, "*");
                    indexs++
                    if(indexs>20){
                        clearInterval(that.timer)
                    }
                },500)
            }
        },
        destroyed(){
            clearInterval(this.timer)
        }


    }
</script>

<style lang="scss" scoped>
    .sgsmanagerContent {
        width: calc(100% - 160px);
        padding: 0 80px;
        @include product_bg_color();
        height: 1000px;
    }

    .iframesgsmanagerContent {
        width: 100%;
        height: 1000px;

    }
</style>